export default __webpack_public_path__ + "static/media/repeat.1456ca15.svg";